namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_entity_catalog, {
		
		Menu: {
			flex: {
				basis: '18rem',
			},
		},
		
	} )
	
}
